import { render, staticRenderFns } from "./MemberMentionTextArea.vue?vue&type=template&id=bb8fab0e&"
import script from "./MemberMentionTextArea.vue?vue&type=script&lang=js&"
export * from "./MemberMentionTextArea.vue?vue&type=script&lang=js&"
import style0 from "./MemberMentionTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports